var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomInDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6815 5.75341H9.73055V9.65535H5.8286V11.6063H9.73055V15.5083H11.6815V11.6063H15.5835V9.65535H11.6815V5.75341ZM10.706 0.875977C5.32135 0.875977 0.951172 5.24615 0.951172 10.6308C0.951172 16.0155 5.32135 20.3857 10.706 20.3857C16.0907 20.3857 20.4609 16.0155 20.4609 10.6308C20.4609 5.24615 16.0907 0.875977 10.706 0.875977ZM10.706 18.4347C6.40414 18.4347 2.90214 14.9327 2.90214 10.6308C2.90214 6.32894 6.40414 2.82695 10.706 2.82695C15.0079 2.82695 18.5099 6.32894 18.5099 10.6308C18.5099 14.9327 15.0079 18.4347 10.706 18.4347Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInDisabled);
export default __webpack_public_path__ + "static/media/zoom-in-disabled.f78675fcaeeadfec79e9a2b6838dfa9e.svg";
export { ForwardRef as ReactComponent };